import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InventoryComponent } from './inventory.component';
import { DashboardInventoryComponent } from './components/dashboard-inventory/dashboard-inventory.component';
import { ItemDetailComponent } from './components/item-detail/item-detail.component';
import { StockMovementFormComponent } from './components/stock-movement-form/stock-movement-form.component';
import { StockTransferFormComponent } from './components/stock-transfer-form/stock-transfer-form.component';
import { TableTestItemsSummaryComponent } from './components/table-test-items-summary/table-test-items-summary.component';
import { AuthGuardSections } from 'app/auth/_helpers/auth.guard';
import { Roles } from '@modelos/interfaces/operation-result-types';

const routes: Routes = [
  { path: '', redirectTo: 'items', pathMatch: 'full' },
  { 
    path: 'dashboard', 
    component: DashboardInventoryComponent,
    canActivate: [AuthGuardSections],
    data: { breadcrumb: 'Información General', roles: [Roles.ADMIN, Roles.INVENTORY_MANAGER, Roles.SUPERVISOR, Roles.DIRECTOR] }
  },
  { path: 'items', component: InventoryComponent, data: { mode: 'items' } },
  { 
    path: 'items/new', 
    component: ItemDetailComponent, 
    canActivate: [AuthGuardSections],
    data: { breadcrumb: 'Nuevo Artículo', roles: [Roles.ADMIN, Roles.INVENTORY_MANAGER] } 
  },
  { path: 'items/:id', component: ItemDetailComponent, data: { breadcrumb: 'Hoja de Vida' } },
  { 
    path: 'items/:itemId/lots/:lotId/quality', 
    loadComponent: () => import('./components/lot-quality-hub/lot-quality-hub.component').then(m => m.LotQualityHubComponent),
    canActivate: [AuthGuardSections],
    data: { breadcrumb: 'Calidad de Lote', roles: [Roles.ADMIN, Roles.INVENTORY_MANAGER, Roles.SUPERVISOR, Roles.DIRECTOR, Roles.ANALYST, Roles.QUALITY] }
  },
  { path: 'movements', component: InventoryComponent, data: { mode: 'movements' } },
  { path: 'movements/new', component: StockMovementFormComponent, data: { breadcrumb: 'Nuevo Movimiento' } },
  { path: 'movements/:id', component: StockMovementFormComponent, data: { breadcrumb: 'Editar Movimiento' } },
  { path: 'transfers', component: InventoryComponent, data: { mode: 'transfers' } },
  { path: 'transfers/new', component: StockTransferFormComponent, data: { breadcrumb: 'Nueva Transferencia' } },
  { path: 'transfers/:id', component: StockTransferFormComponent, data: { breadcrumb: 'Detalle de Transferencia' } },
  { 
    path: 'general', 
    component: InventoryComponent, 
    canActivate: [AuthGuardSections],
    data: { mode: 'general', breadcrumb: 'Generales', roles: [Roles.ADMIN, Roles.INVENTORY_MANAGER] } 
  },
  { path: 'test-items-summary', component: TableTestItemsSummaryComponent, data: { breadcrumb: 'Resumen Ítems de Ensayo' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InventoryRoutingModule { }
